import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { formFlattenedObject } from 'Angular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class SecurityListService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getLength(securitylistName, securityGroup, validDetailedSecurityTypes) {
        const getParams = formFlattenedObject({ validDetailedSecurityTypes }, ['validDetailedSecurityTypes']);
        const urlParams = { securitylistName, securityGroup };
        const url = this.urlsService.getUrl(this.urlsService.SECURITY_LISTS.SECURITYLIST_LENGTH, urlParams);
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    getMembers(securitylistName, securityGroup, validDetailedSecurityTypes) {
        const getParams = formFlattenedObject({ validDetailedSecurityTypes }, ['validDetailedSecurityTypes']);
        const urlParams = { securitylistName, securityGroup };
        const url = this.urlsService.getUrl(this.urlsService.SECURITY_LISTS.SECURITYLIST_MEMBERS, urlParams);
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
}
SecurityListService.ɵfac = function SecurityListService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityListService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SecurityListService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SecurityListService, factory: SecurityListService.ɵfac, providedIn: 'root' });
